import React from 'react'
import {Box, Text} from '@chakra-ui/react'
import HybridLink from '../hybrid-link'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {HYBRID_EXTERNAL} from '../../constants'

const TextAndLink = ({textColor, href, hybridHref, message}) => {
    return (
        <Box textAlign="center">
            <Text textStyle="Regular Small" color={textColor ? textColor : null}>
                <FormattedMessage
                    {...message}
                    values={{
                        textlink: (chunks) => (
                            <HybridLink
                                page={HYBRID_EXTERNAL}
                                href={href}
                                hybridHref={hybridHref}
                                isExternal
                                fontSize="sm"
                                color="inherit"
                            >
                                {chunks}
                            </HybridLink>
                        )
                    }}
                    color={textColor}
                />
            </Text>
        </Box>
    )
}

export default TextAndLink

TextAndLink.propTypes = {
    textColor: PropTypes.string,
    href: PropTypes.string,
    hybridHref: PropTypes.string,
    message: PropTypes.any
}
